"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _table = _interopRequireDefault(require("../../../core/table"));
var _startListUtils = _interopRequireDefault(require("./start-list-utils"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _ref = /*#__PURE__*/_react.default.createElement("th", null, "RTC");
var _ref2 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Bib");
var _ref3 = /*#__PURE__*/_react.default.createElement("th", null, "Ranking");
var _ref4 = /*#__PURE__*/_react.default.createElement("th", null);
var _ref5 = /*#__PURE__*/_react.default.createElement("th", null, "Age");
var _ref6 = /*#__PURE__*/_react.default.createElement("th", null, "Club");
var _ref7 = /*#__PURE__*/_react.default.createElement("td", null);
class StartListTable extends _react.Component {
  render() {
    const splitRaces = (0, _startListUtils.default)(this.props.startListRuns).filter(splitRace => {
      return splitRace.startListEntries.length || splitRace.holdingPlaces.length;
    });

    // the styled components are purely to improve the layout of the printed version of the start list
    // Tr shrinks all the table rows. Tbody should stop breaks within each group but does not always do so
    // successfully (depends on browser).
    const Tr = _styledComponents.default.tr`
      @media print {
        font-size: 0.6em;
        line-height: 0.6em;
      }
    `;
    const H3 = _styledComponents.default.h3`
      @media print {
        font-size: 1em;
        line-height: 1em;
        margin-bottom: 0em;
        margin-top: 0.1em;
      }
      margin-top: 0.5em;
    `;
    const Tbody = _styledComponents.default.tbody`
      @media print {
        page-break-inside: avoid;
      }
    `;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_table.default, null, splitRaces.map(splitRace => /*#__PURE__*/_react.default.createElement(Tbody, {
      key: splitRace.id
    }, /*#__PURE__*/_react.default.createElement(Tr, null, /*#__PURE__*/_react.default.createElement("th", {
      className: "text-primary",
      colSpan: this.props.displayFreeCode ? 9 : 8
    }, /*#__PURE__*/_react.default.createElement(H3, null, splitRace.race.raceName, splitRace.runSplitNumber === 1 ? ' A' : +splitRace.runSplitNumber === 2 ? ' B' : ''))), /*#__PURE__*/_react.default.createElement(Tr, null, _ref, _ref2, /*#__PURE__*/_react.default.createElement("th", {
      colSpan: splitRace.race.competitionDivision.isRanking ? 2 : 1
    }, "Name"), splitRace.race.competitionDivision.isRanking ? null : _ref3, !this.props.displayFreeCode ? null : _ref4, _ref5, _ref6, this.props.phases.filter(p => splitRace.phaseRefs.indexOf(p.refCode) !== -1).map(phase => /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right",
      key: phase.refCode
    }, phase.description))), splitRace.startListEntries.map(entry => /*#__PURE__*/_react.default.createElement(Tr, {
      key: entry.id
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, entry.rtcRefs), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, entry.startListBib), /*#__PURE__*/_react.default.createElement("td", {
      colSpan: splitRace.race.competitionDivision.isRanking ? 2 : 1
    }, entry.bibName), splitRace.race.competitionDivision.isRanking ? null : /*#__PURE__*/_react.default.createElement("td", null, entry.bibNumber ? entry.classDivision.rankingDivisionDescription + ' ' : '', entry.classDivision.classDescription + ' ', entry.bibNumber || ''), !this.props.displayFreeCode ? null : /*#__PURE__*/_react.default.createElement("td", null, entry.freeCode), /*#__PURE__*/_react.default.createElement("td", null, entry.ageCategoryDescription), /*#__PURE__*/_react.default.createElement("td", null, entry.entryText), this.props.phases.filter(p => splitRace.phaseRefs.indexOf(p.refCode) !== -1).map(phase => /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right",
      key: phase.refCode
    }, entry.startTimes[phase.refCode])))), splitRace.holdingPlaces.map(place => /*#__PURE__*/_react.default.createElement(Tr, {
      key: place.place
    }, _ref7, /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right text-muted"
    }, place.place), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-muted",
      colSpan: this.props.displayFreeCode ? 5 : 4
    }, place.name), this.props.phases.filter(p => splitRace.phaseRefs.indexOf(p.refCode) !== -1).map(phase => /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right text-muted",
      key: phase.refCode
    }, place.startTimes[phase.refCode]))))))));
  }
}
var _default = exports.default = StartListTable;